/* unplugin-vue-components disabled */import { render } from "./HelpVersion.vue?vue&type=template&id=eb4b43d4&scoped=true&ts=true"
import script from "./HelpVersion.vue?vue&type=script&lang=ts"
export * from "./HelpVersion.vue?vue&type=script&lang=ts"

import "./HelpVersion.vue?vue&type=style&index=0&id=eb4b43d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb4b43d4"]])

export default __exports__